import { useQuery } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { QueryConfig } from '../api/client';
import { driverApi, DriverTasksArrayResponse } from '../services/driverApi';
import { isValidDriverRecordId } from '../utils/driverRecordId';

const getDriverTasks = async (
  token: string,
  driverId: string,
  companyId?: string
): Promise<DriverTasksArrayResponse> => {
  driverApi.setAuthToken(token);
  return driverApi.getTasks(driverId, companyId);
};

export const useDriverTasks = (
  driverId: string,
  companyId?: string,
  config?: QueryConfig<typeof getDriverTasks>
) => {
  const { getAccessTokenSilently, isAuthenticated } = useHybridAuth();

  const result = useQuery({
    ...config,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return getDriverTasks(token, driverId, companyId);
    },
    queryKey: ['driver-tasks', driverId, companyId],
    enabled: isAuthenticated && isValidDriverRecordId(driverId),
    staleTime: 2 * 60 * 1000, // 2 minutes for tasks data
    refetchInterval: 2 * 60 * 1000, // Refetch tasks every 2 minutes
    refetchIntervalInBackground: true, // Keep refetching in background
    refetchOnWindowFocus: true, // Refetch when window regains focus
  });

  return result;
};
